import styled from 'styled-components'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'

export const StyledSelectorDrawer = styled(Drawer)`
  display: flex;
  justify-content: center;
  // backdrop-filter: blur(1px);
  background-color: rgba(106, 109, 210, 0.2);
  .MuiPaper-root {
    height: 70vh;
    width: 70%;
    left: auto;
    right: auto;
    background: #2e2e2e;
    border: 1px solid #ffffff;
    border-radius: 40px 40px 0px 0px;
    padding: 45px 15px 0px 55px;
    overflow: hidden;
  }
`

export const SelectorDrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 43px;
`

export const StyledBackButton = styled(IconButton)`
  height: 48px;
  width: 40px;
  color: #ffffff !important;
`

export const SelectedHeaderContent = styled.div`
  padding-left: 45px;
  font-family: 'heroregular';
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 36px;
  color: #ffffff;
`

export const SelectorDrawerSave = styled.button`
  width: 180px;
  height: 52px;
  background: #323232;
  border: 2px solid #939393;
  box-shadow: 7px 4px 31px rgba(0, 0, 0, 0.58);
  border-radius: 36px;
  font-family: 'heroregular';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;

  color: #ffffff;
`

export const SelectorDrawerList = styled.div`
  padding-top: 68px;
  overflow-y: auto; /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

export const StyledDrawerItemContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
  padding: 10px 0;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }
  
  @media (min-width: 1280px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 28px;
  }
  
  @media (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  
  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
`

export const StyledDrawerItemWrapper = styled.div`
  position: relative;
  &:hover {
    cursor: pointer;
    transform: translateY(-4px);
    transition: transform 0.3s ease;
  }
  transition: transform 0.3s ease;
`

export const StyledDrawerItem = styled.div`
  width: 100%;
  height: 202px;
  
  /* Glass effect */
  background: ${(props) => 
    props.isSelected 
      ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.15) 100%)' 
      : 'linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%)'
  };
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: ${(props) => 
    props.isSelected 
      ? '2px solid rgba(50, 186, 124, 0.6)' 
      : '1px solid rgba(255, 255, 255, 0.18)'
  };
  border-radius: 15px;
  padding: 16px;
  display: flex;
  overflow: hidden;
  position: relative;
  box-shadow: ${(props) => 
    props.isSelected
      ? '0 8px 32px rgba(50, 186, 124, 0.3), 0 4px 16px rgba(0, 0, 0, 0.2)'
      : '0 8px 32px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(0, 0, 0, 0.08)'
  };
  
  /* Subtle gradient overlay for depth */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${(props) => 
      props.isSelected
        ? 'linear-gradient(135deg, rgba(50, 186, 124, 0.1) 0%, transparent 100%)'
        : 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%)'
    };
    border-radius: 15px;
    pointer-events: none;
  }
  
  &:hover {
    border-color: ${(props) => 
      props.isSelected 
        ? 'rgba(50, 186, 124, 0.8)' 
        : 'rgba(255, 255, 255, 0.3)'
    };
    box-shadow: ${(props) => 
      props.isSelected
        ? '0 12px 40px rgba(50, 186, 124, 0.4), 0 6px 20px rgba(0, 0, 0, 0.25)'
        : '0 12px 40px rgba(0, 0, 0, 0.15), 0 6px 20px rgba(0, 0, 0, 0.1)'
    };
    transform: translateY(-2px);
    transition: all 0.3s ease;
  }
  
  transition: all 0.3s ease;
  
  @media (max-width: 640px) {
    height: 160px;
    padding: 12px;
    border-radius: 12px;
  }
  
  @media (max-width: 480px) {
    height: 140px;
    padding: 10px;
    border-radius: 10px;
  }
  
  @media (min-width: 1280px) {
    height: 202px;
    padding: 16px;
  }
`

export const DrawerItemName = styled.div`
  min-width: 125px;
  padding: 4px;
  font-family: 'heroregular', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 24px;
  color: ${(props) => (props.altText ? 'rgba(255, 255, 255, 0.6)' : 'rgba(255, 255, 255, 0.95)')};
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 1;
  position: relative;
  
  @media (max-width: 640px) {
    font-size: 18px;
    line-height: 20px;
    min-width: 100px;
  }
  
  @media (max-width: 480px) {
    font-size: 16px;
    line-height: 18px;
    min-width: 90px;
  }
`

export const DrawerCheckedImage = styled.img`
  position: absolute;
  top: 0.5px;
  right: 0.5px;
  width: 32px;
  height: 32px;
  z-index: 2;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  
  @media (max-width: 640px) {
    width: 28px;
    height: 28px;
  }
  
  @media (max-width: 480px) {
    width: 24px;
    height: 24px;
  }
`

export const DrawerItemImageWrapper = styled.div`
  padding-top: 60px;
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  
  @media (max-width: 640px) {
    padding-top: 40px;
  }
  
  @media (max-width: 480px) {
    padding-top: 30px;
  }
`

export const DrawerItemImageContainer = styled.div`
  width: 160px;
  height: 160px;
  transform: rotate(42deg);
  border-radius: 29px;
  overflow: hidden;
  box-shadow: 0px 3px 29px 0px rgba(146, 146, 146, 0.8), 3px 0px 29px 0px rgba(146, 146, 146, 0.8);
  z-index: 0;
  position: relative;
  
  @media (max-width: 640px) {
    width: 120px;
    height: 120px;
    border-radius: 24px;
  }
  
  @media (max-width: 480px) {
    width: 100px;
    height: 100px;
    border-radius: 20px;
  }
`

export const DrawerItemImage = styled.div`
  width: 180px;
  height: 172px;
  background-image: url(${(props) => props.icon});
  background-repeat: no-repeat;
  background-size: 85% 85%;
  background-position: center;
  transform: rotate(-42deg) scale(1.4);
  
  @media (max-width: 640px) {
    width: 150px;
    height: 144px;
    transform: rotate(-42deg) scale(1.3);
  }
  
  @media (max-width: 480px) {
    width: 130px;
    height: 125px;
    transform: rotate(-42deg) scale(1.2);
  }
`
